import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import EmptyState from '../../../shared/empty-state/components/empty-state';
import RenderIf from '../../../shared/render-if/components/render-if';
import PageHeader from '../../../shared/page-header/components/page-header';
import ButtonsSelector from '../../../shared/buttons-selector/components/buttons-selector';
import KeysTable from './keys-table';
import DeactivateKeyModal from './deactivate-key-modal';
import b2bConstants from '../constants/b2b-constants';
import B2BHelpers from '../helpers/b2b-helpers';
import { getKeys, generateKey } from '../actions/b2b-actions';

class B2B extends Component {
  state = {
    active: b2bConstants.filters[0],
  };

  componentDidMount() {
    const { getKeys } = this.props;

    getKeys();
  }

  onFilterChange(active) {
    this.setState({ active });
  }

  render() {
    const { t } = this.context;
    const { active } = this.state;
    const { httpInProgress, keys, generateKey, showDeactivateKeyModal, selectedKey, deactivateKeyInProgress, generateKeyInProgress } = this.props;
    const filteredKeys = B2BHelpers.filterKeys(keys, active.value);

    return (
      <div className="b2b-container">
        <RenderIf if={showDeactivateKeyModal && selectedKey}>
          <DeactivateKeyModal />
        </RenderIf>
        <div className="display-flex-vertical">
          <PageHeader title={'B2B.TITLE'} className="flex-pull-left" />
          <RenderIf if={!httpInProgress && keys && keys.length > 0}>
            <div className={`transparent-btn flex-pull-right ${deactivateKeyInProgress || generateKeyInProgress ? 'transparent-btn-disabled' : ''}`} onClick={() => generateKey()}>
              {t('B2B.GENERATE_NEW_KEY')}
            </div>
          </RenderIf>
        </div>
        <RenderIf if={!httpInProgress && keys && keys.length === 0}>
          <EmptyState title={'B2B.EMPTY_STATE_TITLE'} actionButtonLabel={'B2B.EMPTY_STATE_BTN'} callback={generateKey} />
        </RenderIf>
        <RenderIf if={!httpInProgress && keys && keys.length > 0}>
          <div className="row">
            <div className="col-md-12 display-flex-center">
              <div className="col-md-5">
                <ButtonsSelector items={b2bConstants.filters} selectedValue={active} onClick={this.onFilterChange.bind(this)} />
              </div>
            </div>
          </div>
        </RenderIf>
        <RenderIf if={!httpInProgress && keys && keys.length > 0}>
          <KeysTable passedKeys={filteredKeys} />
        </RenderIf>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  httpInProgress: state.httpInProgressReducer.httpInProgress,
  keys: state.b2bReducer.keys,
  selectedKey: state.b2bReducer.selectedKey,
  showDeactivateKeyModal: state.b2bReducer.showDeactivateKeyModal,
  generateKeyInProgress: state.b2bReducer.generateKeyInProgress,
  deactivateKeyInProgress: state.b2bReducer.deactivateKeyInProgress,
});

const mapDispatchToProps = dispatch => ({
  getKeys: () => {
    dispatch(getKeys());
  },
  generateKey: () => {
    dispatch(generateKey());
  },
});

B2B.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(B2B);



// WEBPACK FOOTER //
// ./src/app/main/b2b/components/b2b.js